import { Injectable } from '@angular/core';
import { Option, StaticStringSelectDisplayService } from '../static-string-select/static-string-select.component';

@Injectable({ providedIn: 'root' })
export class AuxiliaryDataDropdownDisplayService extends StaticStringSelectDisplayService {
  options: Option[];

  initialize(filterData: Option[]): void {
    this.options = filterData;
  }
}
